// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  margin: 0;
  padding: 0;
  overflow: hidden; /* Impede a rolagem na raiz se a ideia é um dashboard fixo */
  height: 100%;
  width: 100%;
}

body {
    margin-top: 0;
    margin-left: 0;
}

.dock-window {
    width: 100%;
    top: 100vh;
    position: absolute;
    z-index: 1;
}

.loteText {
    background-color: #00000000;
    color: #2EF
}

.proc-dialog-indiv {
    padding-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.proc-dialog-budiv {
    text-align: center;
    padding-top: 1rem;
}

.proc-dialog-indiv > span {
    width: 12rem;
}

.check-dialog {
    width: min(100%, 640px);
}
.check-dialog > p {
    text-align: center;
}
.check-dialog > div {
    text-align: center;
}
.check-dialog button {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
}

.buttons-group-flex {
    display: flex;
    align-items: center;
    flex-direction: column;
}

.buttons-group-flex > button {   
    margin: 0.4rem
}

.p-progress-spinner-circle {
  stroke: #007bff !important; /* Exemplo: cor azul primária. Use !important se necessário para sobrescrever. */
  /* stroke: var(--primary-color) !important; // Se estiver usando variáveis CSS do PrimeReact */
}
.dialog-permissoes {
    max-width: 100dvw;
}
div.checkbox-perms {
    max-height: calc(100dvh - 15.5rem);
    border-bottom: solid 1px #e5e7eb;
    border-radius: 6px;
    position: relative;
}
.checkbox-perms p {
    margin: 0px;
}
.checkbox-perms td {
    text-align: center;
}
div.checkbox-loadblock{
    background-color: #444;
    opacity: 0.5;
    position: absolute;
    right: 0px;
    left: 0px;
    z-index: 4;
    height: 100%;
    align-items: center;
}
div.checkbox-buttons{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 1rem;
    margin-top: 1rem;
}
.checkbox-perms div.p-checkbox {
    margin-right: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB,EAAE,4DAA4D;EAC9E,YAAY;EACZ,WAAW;AACb;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI;AACJ;;AAEA;EACE,0BAA0B,EAAE,gFAAgF;EAC5G,8FAA8F;AAChG;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kCAAkC;IAClC,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB","sourcesContent":["html, body {\n  margin: 0;\n  padding: 0;\n  overflow: hidden; /* Impede a rolagem na raiz se a ideia é um dashboard fixo */\n  height: 100%;\n  width: 100%;\n}\n\nbody {\n    margin-top: 0;\n    margin-left: 0;\n}\n\n.dock-window {\n    width: 100%;\n    top: 100vh;\n    position: absolute;\n    z-index: 1;\n}\n\n.loteText {\n    background-color: #00000000;\n    color: #2EF\n}\n\n.proc-dialog-indiv {\n    padding-bottom: 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.proc-dialog-budiv {\n    text-align: center;\n    padding-top: 1rem;\n}\n\n.proc-dialog-indiv > span {\n    width: 12rem;\n}\n\n.check-dialog {\n    width: min(100%, 640px);\n}\n.check-dialog > p {\n    text-align: center;\n}\n.check-dialog > div {\n    text-align: center;\n}\n.check-dialog button {\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n}\n\n.buttons-group-flex {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n}\n\n.buttons-group-flex > button {   \n    margin: 0.4rem\n}\n\n.p-progress-spinner-circle {\n  stroke: #007bff !important; /* Exemplo: cor azul primária. Use !important se necessário para sobrescrever. */\n  /* stroke: var(--primary-color) !important; // Se estiver usando variáveis CSS do PrimeReact */\n}\n.dialog-permissoes {\n    max-width: 100dvw;\n}\ndiv.checkbox-perms {\n    max-height: calc(100dvh - 15.5rem);\n    border-bottom: solid 1px #e5e7eb;\n    border-radius: 6px;\n    position: relative;\n}\n.checkbox-perms p {\n    margin: 0px;\n}\n.checkbox-perms td {\n    text-align: center;\n}\ndiv.checkbox-loadblock{\n    background-color: #444;\n    opacity: 0.5;\n    position: absolute;\n    right: 0px;\n    left: 0px;\n    z-index: 4;\n    height: 100%;\n    align-items: center;\n}\ndiv.checkbox-buttons{\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 1rem;\n    margin-top: 1rem;\n}\n.checkbox-perms div.p-checkbox {\n    margin-right: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
